import Vue from 'vue'
import Vuex from 'vuex'
import { vuexfireMutations, firestoreAction } from 'vuexfire'// 
import { db } from '../services/db'
import { user } from "./storeUser"

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        config: {
            backend: 'firebase',
            persistence: 'SESSION', // LOCAL, SESSION
            storage: {
                //passfotos: "https://firebasestorage.googleapis.com/v0/b/oeskb-dev.appspot.com/o/passfotos%2F",
                //passfotos: "https://firebasestorage.googleapis.com/v0/b/oeskb-test.appspot.com/o/passfotos%2F",
                passfotos: "https://firebasestorage.googleapis.com/v0/b/oeskb-app.appspot.com/o/passfotos%2F",
            },
            algolia: {
                app_id: 'M9IY3UIYOM',
                search_key: '274c0a741db468783e768ece14ae8fb9',
                //index: 'oeskb_dev',
                //index: 'oeskb_test'
                index: 'oeskb_app'
            },
            batchUpdate: {
            // dev
                /*
                user: '',
                documentId: '',
                */
            // test
                /*
                user: 'KK5Q146ASkgtWURtiQi0Gsg61UR2',
                documentId: '0ppuToSNLnpt710B9ZDT',
                */
            // dev
                /*
                user: '',
                documentId: '',
                */
            },
        },
        overlay: {
            active: false,
            warning: false,
            action: () => {},
        },
        globalSnack: {
            show: false,
            color: 'error',
            timeout: 4000,
            text: '',
            dynamicText: null,
            actionMethod: null,
            actionButtonI18n: '',
        },
        realtime: {
            vereinsspieler: [],
            vereinsspielerExpired: [],
            spielerSearchResult: [],
            spielerSearchResultSingle: null,
            pendingActions: [],
            pendingNewMitglieder: [],
            pendingPassUploads: [],
            pendingActionsAll: [],
            pendingLeihspieler: [],
            //landesverband: null,
            landesverbaende: {
                1: null,
                11: null,12: null,13: null,14: null,15: null,16: null,17: null,18: null,19: null,
                21: null,22: null,23: null,24: null,25: null,26: null,27: null,28: null,29: null,
            },
            spieleWaiting: null, // for gast team, need to confirm spielberichte
            spielePending: null, // for heim team, need to enter spielberichte
            spieleCreated: null, // for heim team, waiting for confirmation of gast team
            spieleComplete: null, // for all teams, all spielberichte where verein was involved
            users: [],
        },
        snapshots: {
            vereinsdatenblaetterPrint: ['hallo'],
            bestaetigungsfristen: null,
        },
        local: {
            printPaesse: null,
            printContainer: null,
            printBackReset: null,
            bindsRealtimeList: false,
            sportJahr: null,
            loader: false,
            nationaleLigen: {id: '1', name: 'Nationale Ligen', nameShort: 'Nationale Ligen ', sportart: 'classic', wappen: 'Oesterreich.png', prefix: 'Österreichische '},
            landesverbaende: [
                {id: '11', name: 'LV Burgenland - Kegeln', nameShort: 'Burgenland ', sportart: 'classic', wappen: 'Burgenland.png', abbreviation: 'B', prefix: 'Burgenländische '},
                {id: '12', name: 'LV Kärnten - Kegeln', nameShort: 'Kärnten ', sportart: 'classic', wappen: 'Kaernten.png', abbreviation: 'K', prefix: 'Kärnter '},
                {id: '13', name: 'LV Niederösterreich - Kegeln', nameShort: 'Niederösterreich ', sportart: 'classic', wappen: 'Niederoesterreich.png', abbreviation: 'NÖ', prefix: 'Niederösterr. '},
                {id: '14', name: 'LV Oberösterreich - Kegeln', nameShort: 'Oberösterreich ', sportart: 'classic', wappen: 'oeskb.png', abbreviation: 'OÖ', prefix: 'Oberösterr. '},
                {id: '15', name: 'LV Salzburg - Kegeln', nameShort: 'Salzburg ', sportart: 'classic', wappen: 'Salzburg.png', abbreviation: 'S', prefix: 'Salzburger '},
                {id: '16', name: 'LV Steiermark - Kegeln', nameShort: 'Steiermark ', sportart: 'classic', wappen: 'oeskb.png', abbreviation: 'ST', prefix: 'Steirische '},
                {id: '17', name: 'LV Tirol - Kegeln', nameShort: 'Tirol ', sportart: 'classic', wappen: 'Tirol.png', abbreviation: 'T', prefix: 'Tiroler '},
                {id: '18', name: 'LV Vorarlberg - Kegeln', nameShort: 'Vorarlberg ', sportart: 'classic', wappen: 'oeskb.png', abbreviation: 'V', prefix: 'Vorarlberger '},
                {id: '19', name: 'LV Wien - Kegeln', nameShort: 'Wien ', sportart: 'classic', wappen: 'Wien.png', abbreviation: 'W', prefix: 'Wiener '},
                {id: '21', name: 'LV Burgenland - Bowling', nameShort: 'Burgenland ', sportart: 'bowling'},
                {id: '22', name: 'LV Kärnten - Bowling', nameShort: 'Kärnten ', sportart: 'bowling'},
                {id: '23', name: 'LV Niederösterreich - Bowling', nameShort: 'Niederösterreich ', sportart: 'bowling'},
                {id: '24', name: 'LV Oberösterreich - Bowling', nameShort: 'Oberösterreich ', sportart: 'bowling'},
                {id: '25', name: 'LV Salzburg - Bowling', nameShort: 'Salzburg ', sportart: 'bowling'},
                {id: '26', name: 'LV Steiermark - Bowling', nameShort: 'Steiermark ', sportart: 'bowling'},
                {id: '27', name: 'LV Tirol - Bowling', nameShort: 'Tirol ', sportart: 'bowling'},
                {id: '28', name: 'LV Vorarlberg - Bowling', nameShort: 'Vorarlberg ', sportart: 'bowling'},
                {id: '29', name: 'LV Wien - Bowling', nameShort: 'Wien ', sportart: 'bowling'},
            ],
            ligaTypes:[{value: 'f', label: 'Damen', sort: 10, type: 'Liga'},
                        {value: 'm', label: 'Herren', sort: 20, type: 'Liga'},
                        {value: 'other', label: 'Sonstige', sort: 30, type: 'Liga'},
                        {value: 'xc', label: 'Cup', sort: 40, type: 'Cup'},
                {value: 'ösm', label: 'Meisterschaft AK', labelLong: 'Staatsmeisterschaft', labelLongAlt: 'Landesmeisterschaft',
                 type: 'Meisterschaft', sort: 50},
                {value: 'öms', label: 'Meisterschaft Ü50/Ü60', labelLong: 'Meisterschaft Ü50/Ü60', labelLongAlt: 'Meisterschaft Ü50/Ü60',
                 type: 'Meisterschaft', sort: 60},
                {value: 'ömj', label: 'Meisterschaft Nachwuchs', labelLong: 'Meisterschaft Nachwuchs', labelLongAlt: 'Meisterschaft Nachwuchs',
                    type: 'Meisterschaft', sort: 70},
            ],
            semesterTypes: [
                {value: 'H', label: 'Herbst'},
                {value: 'F', label: 'Frühjahr'},
            ],
            countryIso: {
                AUT: 'at', BEL: 'be', BIH: 'ba', BUL: 'bg', CRO: 'hr', CZE: 'cz', ESP: 'es',
                FRA: 'fr', GBR: 'gb', GER: 'de', HUN: 'hu', IRN: 'ir', ITA: 'it', JPN: 'jp',
                KEN: 'ke', KOR: 'kr', LIE: 'li', MKD: 'mk', MNE: 'me', NED: 'nl', PHI: 'ph', POL: 'pl',
                ROM: 'ro', ROU: 'ro', RUS: 'ru', SLO: 'si', SRB: 'rs', STL: 'xx',
                SUI: 'ch', SVK: 'sk', SYR: 'sy', THA: 'th', TUR: 'tr', UKR: 'ua', USA: 'us',
                YUG: 'xx', andere: 'xx'
            },
        },
    },
    mutations: {
        ...vuexfireMutations,
    },
    actions: {
        bindRealtimeList: firestoreAction(({ state, bindFirestoreRef }, params) => {
            return bindFirestoreRef('realtime.' + params.storeField, db.collection(params.collection)
                    .where(params.queryField, params.queryOperator, params.queryValue)
                //.limit(params.limit)
            )
                .then(()=> { state.local.bindsRealtimeList = false;
                    console.log ("----- STORE bindTemp: SUCCESSFUL" ); return 'successful';  })
                .catch(() => {
                    state.local.bindsRealtimeList = false;
                    console.log ("----- STORE bindTemp: NOTHING TO BIND", params.collection );
                });
        }),
        bindFullRealtimeList: firestoreAction(({ state, bindFirestoreRef }, params) => {
            return bindFirestoreRef('realtime.' + params.storeField, db.collection(params.collection)
                //.limit(params.limit)
            )
                .then(()=> { state.local.bindsRealtimeList = false;
                    console.log ("----- STORE bindTemp: SUCCESSFUL" ); return 'successful';  })
                .catch(() => {
                    state.local.bindsRealtimeList = false;
                    console.log ("----- STORE bindTemp: NOTHING TO BIND", params.collection );
                });
        }),
        bindRealtimeDocument: firestoreAction(({ state, bindFirestoreRef }, params) => {
            return bindFirestoreRef('realtime.' + params.storeField, db.collection(params.collection)
                .doc(params.docId))
                .then(()=> {
                    state.local.bindsRealtimeList = false;
                    console.log ("realtime Doc bound" );
                })
                .catch(() => {
                    state.local.bindsRealtimeList = false;
                    console.log ("----- STORE bindLocal: NOTHING TO BIND" );
                });
        }),
        unbindRealtimeList: firestoreAction(({ unbindFirestoreRef }, list) => {
                unbindFirestoreRef('realtime.' + list)
        }),
        setSnapshot(context, params){
            const docRef = db.collection(params.collection).doc(params.docId);
            docRef.get().then((doc) => {
                if (doc.exists) {
                    context.state.snapshots[params.storeField] = params.emptyObject;
                    context.state.snapshots[params.storeField].setFromDataObject(doc.data());
                    context.state.snapshots[params.storeField].id = params.docId;
                } else {
                    // doc.data() will be undefined in this case
                    console.log("No such document!");
                }
            }).catch((error) => {
                console.log("Error getting document:", error);
            });
        },
        setSnapshotList(context, params){
            context.state.snapshots[params.storeField] = [];
            db.collection(params.collection).where(params.queryField, params.queryOperator, params.queryValue)
                .get()
                .then((querySnapshot) => {
                    querySnapshot.forEach((doc) => {
                        // doc.data() is never undefined for query doc snapshots
                        let data = doc.data();
                        data.id = doc.id;
                        context.state.snapshots[params.storeField].push(data);
                    });
                })
                .catch((error) => {
                    console.log("Error getting documents: ", error);
                });
        },
    // firebase getters (not in store)
        getTempSnapshot(context, params){
            return new Promise( (resolve) => {
                const docRef = db.collection(params.collection).doc(params.docId);
                docRef.get().then((doc) => {
                    if (doc.exists) {
                        let data = doc.data();
                        data.id = params.docId;
                        resolve({successful: true, content: data})
                    } else {
                        // doc.data() will be undefined in this case
                        resolve({successful: false, content: "No such document!"});
                    }
                }).catch((error) => {
                    console.log("Error getting document:", error);
                    resolve({successful: false, content: error})
                });
            })
        },
        getTempSnapshotList(context, params){
            return new Promise( (resolve) => {
                const docRef = db.collection(params.collection);
                docRef.where(params.queryField, params.queryOperator, params.queryValue)
                    .get()
                    .then((querySnapshot) => {
                        let list = []
                        querySnapshot.forEach( (doc) => {
                            let item = doc.data();
                            item.id = doc.id;
                            list.push(item)
                        });
                        resolve({successful: true, content: list})
                }).catch((error) => {
                    console.log("Error getting document:", error);
                    resolve({successful: false, content: error})
                });
            })
        },
        setVereinslistForLV(context, params){
            if ( !context.state.realtime.landesverbaende[params.lvId] ) {
                context.dispatch('bindRealtimeDocument', {
                    collection: 'landesverbaende',
                    docId: params.lvId,
                    storeField: 'landesverbaende.'+params.lvId,
                });
            }
        },
        clearSnackbar(context){
            context.state.globalSnack = {
                show: false,
                color: 'error',
                timeout: 4000,
                text: '',
                dynamicText: null,
                actionMethod: null,
                actionButtonI18n: '',}
        }
    },
    getters: {
        getFromRealtimeListById: (state) => (list, id) => {
            const dataList = state.realtime[list];
            return dataList.find(item => item.id === id);
        },
        getFromAnyRealtimeListById: (state) => (lists, id) => {
            for ( let i = 0; i < lists.length; i++ ) {
                const dataList = state.realtime[lists[i]];
                console.log ("XXXXXXXXXXXXXXXXXXXXXXXXXXXXX", lists[i], state.realtime[lists[i]]);
                let result = dataList.find(item => item.id === id);
                if ( result ) { return result }
            }
            return null;
        },
        getListFromKeys: (state) => (folder, document, parentKey, sort) => {
            let list = [];
            Object.keys(state[folder][document][parentKey]).forEach( (key) => {
                let item = state[folder][document][parentKey][key];
                item.id = key;
                list.push(item);
            });
            list.sort((a, b) => a[sort] > b[sort] ? 1 : -1);
            return list;
        },
        getListByStoreLink: () => (link, sort) => {
            let list = [];
            Object.keys(link).forEach( (key) => {
                let item = link[key];
                item.id = key;
                list.push(item);
            });
            list.sort((a, b) => a[sort] > b[sort] ? 1 : -1);
            return list;
        },
    },
    modules: {
        user: user,
    }
})
